import React from 'react'
import ButtonProps from './type'

const Button: React.FC<ButtonProps> = (props) => {
    return (
        <button
            onClick={props.onClick}
            className={`btn btn-${props.variant ? `${props.variant}` : 'primary'} 
            ${props.variant === 'outline-success-round' && 'btn-outline-success rounded-pill'}
            ${props.size ? props.size : ''} ${props.active ? 'active' : ''} mt-2`}
            type={props.type}
            disabled={props.disabled}
        >
            {props.children} {/* Include children prop here */}
        </button>
    )
}

export default Button
